import { render } from "./QuotationButton.vue?vue&type=template&id=3479a241"
import script from "./QuotationButton.vue?vue&type=script&lang=js"
export * from "./QuotationButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__